import {
  PRODUCT_TYPE_ENUMERATION_NAME,
  CONSTANTS,
} from '../../settings/settings';
import { isProductTypeMutualFunds } from '../funds/funds-utility';
import { getPendingTransactionTotalForFund } from '../transactions-util';
import moment from 'moment';

/**
 * Created by trph919 on 10/21/19.
 */

export const isAPP = (productType) => {
  return productType === PRODUCT_TYPE_ENUMERATION_NAME.MANAGED_ACCOUNT;
};

export const isRAS = (productType) => {
  return productType === PRODUCT_TYPE_ENUMERATION_NAME.ADVICE_MANAGED;
};

export const isAPPorMF = (productType) => {
  return isAPP(productType) || isProductTypeMutualFunds(productType);
};

export const isCompatibleIraRegistration = (aType, bType) => {
  return aType === CONSTANTS.ROTH
    ? bType === CONSTANTS.ROTH
    : (aType === CONSTANTS.ROLLOVER || aType === CONSTANTS.TRADITIONAL) &&
        (bType === CONSTANTS.ROLLOVER || bType === CONSTANTS.TRADITIONAL);
};

export const getRasDailyMax = (fund, sellPendingTransactions) => {
  const currentDaySellPendingTransactionTotalForFund =
    getPendingTransactionTotalForFund(
      fund,
      filterCurrentDayPendingTransactions(sellPendingTransactions)
    );
  const nonCurrentDaySellPendingTransactionTotalForFund =
    getPendingTransactionTotalForFund(
      fund,
      filterNonCurrentDayPendingTransactions(sellPendingTransactions)
    );
  const nonRoundedLimit =
    Math.round(
      (fund.balanceAsOf - nonCurrentDaySellPendingTransactionTotalForFund) * 3
    ) /
      100 -
    currentDaySellPendingTransactionTotalForFund;
  return Math.ceil(nonRoundedLimit * 100) / 100;
};

export const filterCurrentDayPendingTransactions = (
  sellPendingTransactions
) => {
  if (!sellPendingTransactions) {
    return [];
  }
  const currentDate = moment().format('MM-DD-YYYY');
  return sellPendingTransactions.filter(
    (p) => currentDate === moment(p.tradeDate).format('MM-DD-YYYY')
  );
};

export const filterNonCurrentDayPendingTransactions = (
  sellPendingTransactions
) => {
  if (!sellPendingTransactions) {
    return [];
  }
  const currentDate = moment().format('MM-DD-YYYY');
  return sellPendingTransactions.filter(
    (p) => currentDate !== moment(p.tradeDate).format('MM-DD-YYYY')
  );
};

export const ADVISOR_HEADSHOT_SIZES = {
  JUMBO: '1x1-Jumbo',
  NORMAL1: '1x1-Normal',
  MINI: '1x1-Mini',
  NORMAL2: '2x3-Normal',
};

export const getSelectedHousehold = (households, financialPlanningGroupID) => {
  return households?.find(
    (household) =>
      household.financialPlanningGroupId === financialPlanningGroupID
  );
};

export const findFinancialAdvisor = (
  households,
  financialAdvisors,
  externalHouseholdId
) => {
  // if only one household => use that advisor
  // if externalHouseholdId is passed in => find household and use that advisor
  // if externalHouseholdId is not passed in, agent is a RAS client => use their advisor
  // if externalHouseholdId is not passed in, agent is not a RAS client, and has access to multiple households => use generic advisor
  if (!financialAdvisors) {
    return null;
  }
  if (
    households.length === 1 &&
    Object.keys(financialAdvisors).length === 1 &&
    households[0].externalHouseholdId === Object.keys(financialAdvisors)[0]
  ) {
    return Object.values(financialAdvisors)[0];
  }
  if (externalHouseholdId) {
    return financialAdvisors[externalHouseholdId];
  }
  const userHousehold = households.find(
    (household) => household.userBelongsToHousehold
  );
  return userHousehold
    ? financialAdvisors[userHousehold.externalHouseholdId]
    : null;
};
